/* eslint-disable camelcase */
export default {
  table: 'table',
  empty_slot: 'Empty',
  loading: 'Loading...',
  no_tables: 'No tables available',
  view_network: 'View Your Current Network',
  navigate_hint: 'Here you can navigate through your open networks',
};
